<script setup>
import KanbanSettings from './KanbanSettings.vue';
const emit = defineEmits(['close']);
</script>

<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-50 bg-black/40" @click.self="emit('close')">
      <div
        class="fixed right-0 top-0 h-full w-[420px] max-w-full bg-n-background border-l border-n-weak shadow-xl flex flex-col"
      >
        <KanbanSettings @close="emit('close')" />
      </div>
    </div>
  </Teleport>
</template>
